import type { DesignationArea } from "react-migration/domains/constraints/designation/hooks/useDesignationAreaByGeometry";

export function areaWithLargestCoverage(areas: DesignationArea[] = []) {
  return areas
    .slice()
    .sort((a, b) => b.category_coverage_percentage - a.category_coverage_percentage)
    .shift();
}
